import { Card, CardBody } from '@heroui/react';
import React, { FC } from 'react';

const CardWrapper: FC<any> = ({ children, className }) => {
  return (
    <Card className="border border-gray-90 h-full shadow-sm rounded-3.5">
      <CardBody className={`p-4 h-full ${className}`}>{children}</CardBody>
    </Card>
  );
};

export default CardWrapper;
